import React, { useCallback } from 'react';
import TextField from '@mui/material/TextField';
import { useFormikContext } from 'formik';
import { prettifyRut, removeSeparators } from 'react-rut-formatter';
import PropTypes from 'prop-types';
import DEFAULT_FILLED_INPUT_CLASS_NAME from '../../theme/constants/filled-input';

const RutField = ({ InputProps }) => {
  const {
    values,
    setFieldValue,
    setFieldTouched,
    validateField,
    touched,
    errors,
  } = useFormikContext();

  const handleRutChange = useCallback(
    (e) => {
      const newRut = e.target.value;
      const cleanedRut = removeSeparators(newRut);
      const formattedRut = prettifyRut(cleanedRut);
      const displayRut = formattedRut !== '0-0' ? formattedRut : '';
      setFieldValue('rut', { formatted: displayRut, raw: cleanedRut }, false);
      setFieldTouched('rut', false);
    },
    [setFieldValue, setFieldTouched, validateField],
  );

  const handleRutBlur = useCallback(() => {
    validateField('rut');
    setFieldTouched('rut', true);
  }, [validateField, setFieldTouched]);

  return (
    <TextField
      name="rut"
      variant="filled"
      placeholder="Ingresa tu RUT"
      fullWidth
      value={values.rut.formatted}
      onChange={handleRutChange}
      onBlur={handleRutBlur}
      error={touched.rut?.raw && !!errors.rut?.raw}
      helperText={
        touched.rut?.raw && errors.rut?.raw
          ? errors.rut.raw
          : undefined
      }
      InputProps={{ ...InputProps, className: DEFAULT_FILLED_INPUT_CLASS_NAME }}
      FormHelperTextProps={{ sx: { minHeight: 24 } }}
    />
  );
};

export default RutField;

RutField.propTypes = {
  InputProps: PropTypes.shape({
  }),
};

RutField.defaultProps = {
  InputProps: {
    sx: {
      border: '1px solid #ccc',
      backgroundColor: '#f9f9f9',
      '&:hover': { backgroundColor: '#F9F9F9' },
    },
  },
};
